import { useUserManager } from "../context/UserManagerContext";

function ProcessCallbacks() {
  const { userManager } = useUserManager();

  const processCallback = async () => {
    // Sign-in redirect caught
    userManager.signinCallback().then((user) => {
      if (user) {
        window.location.href = "/";
      } else {
        console.error("No user found in the callback response");
        window.location.href = "/?error=true";
      }
    })
      .catch((error) => {
        console.error("Error handling authentication callback", error);
        // window.location.href = "/?error=true";
      });
  };

  const processSilentCallback = async () => {
    // Silent sign-in redirect caught
    userManager
      .signinSilentCallback()
      .catch((error) => {
        console.error("Error handling silent signin callback", error);
      });
  };

  return { processCallback, processSilentCallback };
}

export default ProcessCallbacks;